import { CharacterImage } from "@/components/CharacterImage";

/**
 * Pure-CSS phone mockup showing a snapshot of the in-app experience.
 * No external images required beyond the mascot.
 */
export function AppPreviewMockup() {
  return (
    <div className="relative mx-auto w-[280px] md:w-[320px]">
      {/* Glow */}
      <div
        aria-hidden="true"
        className="absolute -inset-8 rounded-[3rem] bg-gradient-to-br from-primary/30 via-accent/20 to-secondary/30 blur-3xl"
      />

      {/* Phone frame */}
      <div className="relative rounded-[3rem] bg-foreground p-3 shadow-2xl ring-1 ring-foreground/20">
        <div className="relative rounded-[2.5rem] overflow-hidden bg-background aspect-[9/19]">
          {/* Notch */}
          <div
            aria-hidden="true"
            className="absolute top-2 left-1/2 -translate-x-1/2 z-20 h-6 w-28 rounded-full bg-foreground"
          />
          {/* Status bar */}
          <div className="absolute inset-x-0 top-0 z-10 flex items-center justify-between px-7 pt-3 text-[10px] font-bold text-foreground/80">
            <span>9:41</span>
            <span>●●●</span>
          </div>

          {/* App content */}
          <div className="absolute inset-0 pt-10 pb-4 px-4 flex flex-col gap-3">
            {/* Greeting */}
            <div className="flex items-center gap-3 px-1">
              <div className="size-10 rounded-full bg-clay/40 ring-2 ring-primary/40 overflow-hidden">
                <CharacterImage code="jad" alt="" loading="lazy" className="size-full object-cover" sizes="40px" />
              </div>

              <div className="flex-1">
                <p dir="rtl" className="font-display-ar text-sm text-primary leading-tight">
                  مرحبا، ليلى!
                </p>
                <p className="font-display-en text-[11px] font-bold text-foreground/60 leading-tight">
                  3-day streak 🔥
                </p>
              </div>
            </div>

            {/* Today's quest card */}
            <div className="rounded-2xl bg-gradient-to-br from-primary to-accent p-3 text-primary-foreground shadow-lg">
              <p className="text-[9px] font-bold uppercase tracking-widest opacity-80">Today's quest</p>
              <p className="font-display-en text-sm font-black leading-tight mt-0.5">
                The Bakery on Jasmine Street
              </p>
              <div className="mt-2 flex items-center justify-between">
                <span className="text-[10px] opacity-90">⏱ 8 min · ages 7–9</span>
                <span className="rounded-full bg-background/25 px-2 py-0.5 text-[9px] font-black">
                  ▶ Play
                </span>
              </div>
            </div>

            {/* Progress strip */}
            <div className="rounded-2xl bg-card border border-clay/40 p-3">
              <div className="flex items-center justify-between mb-1.5">
                <p className="text-[10px] font-bold text-foreground/70">Arabic vocab</p>
                <p className="text-[10px] font-black text-primary">62%</p>
              </div>
              <div className="h-1.5 rounded-full bg-clay/40 overflow-hidden">
                <div className="h-full w-[62%] rounded-full bg-gradient-to-r from-primary to-accent" />
              </div>
            </div>

            {/* Tile row */}
            <div className="grid grid-cols-2 gap-2">
              {[
                { e: "📖", t: "Stories", c: "from-secondary/20 to-secondary/5" },
                { e: "🎬", t: "Videos", c: "from-primary/20 to-primary/5" },
                { e: "🎨", t: "Coloring", c: "from-accent/25 to-accent/5" },
                { e: "🏆", t: "Rewards", c: "from-clay/40 to-clay/10" },
              ].map((tile) => (
                <div
                  key={tile.t}
                  className={`rounded-xl bg-gradient-to-br ${tile.c} p-2.5 border border-clay/30`}
                >
                  <div className="text-xl">{tile.e}</div>
                  <p className="text-[10px] font-bold text-foreground/80 mt-0.5">{tile.t}</p>
                </div>
              ))}
            </div>

            {/* Bottom nav */}
            <div className="mt-auto flex items-center justify-around rounded-2xl bg-foreground/95 px-3 py-2.5 text-background">
              {["🏠", "📚", "🎮", "👨‍👩‍👧"].map((i, k) => (
                <span
                  key={k}
                  className={`text-base ${k === 0 ? "scale-110" : "opacity-50"}`}
                  aria-hidden="true"
                >
                  {i}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
